import React from "react";
import Footer from "../Footer/Footer";
import "./Home.css";
// import { Slide } from "react-slideshow-image";
import Slider from "./Slider";
import WaterSlider from "./WaterSlider";
const Home = () => {
  const slides = [];

  const containerStyles = {
    width: "500px",
    height: "350px",
    margin: "0 auto",
  };

  return (
    <>
      <div className="mainHomeDiv">
        <div className="homeHeader">
          {/* <p className="headerOfSliders"> */}
          <h1 className="indiHeader">Welcome to Sahakar Jal</h1>
          {/* </p> */}
          <p className="descPara">
            Sahakar Jal is a private limited company established in March 2018.
          </p>
          <p className="introPara">
            What started off as a packaged drinking water manufacturer in Goa
            has now spiralled into manufacturing soda. And lately we have begun
            to manufacture cold drinks.
          </p>
        </div>
        <svg
          width="100%"
          height="100%"
          id="svg"
          viewBox="0 0 1440 400"
          xmlns="http://www.w3.org/2000/svg"
          className="transition duration-300 ease-in-out delay-150"
        >
          <defs>
            <linearGradient id="gradient" x1="0%" y1="50%" x2="100%" y2="50%">
              <stop offset="5%" stopColor="#0086c5"></stop>
              <stop offset="95%" stopColor="#0086c5"></stop>
            </linearGradient>
          </defs>
          <path
            d="M 0,400 C 0,400 0,200 0,200 C 143.5,179.53571428571428 287,159.07142857142858 406,163 C 525,166.92857142857142 619.5,195.25 716,206 C 812.5,216.75 911,209.92857142857144 1032,206 C 1153,202.07142857142856 1296.5,201.03571428571428 1440,200 C 1440,200 1440,400 1440,400 Z"
            stroke="none"
            strokeWidth="0"
            fill="url(#gradient)"
            fillOpacity="1"
            className="transition-all duration-300 ease-in-out delay-150 path-0"
            transform="rotate(-180 720 200)"
          ></path>
        </svg>
      </div>

      <div className="history">
        <div
          style={{
            minHeight: "500px",
          }}
          className="coldDrinksHome"
        >
          {/* <p className="headerOfSliders"> */}
          <h1 className="indiHeader">Packaged Drinking Water</h1>
          {/* </p> */}

          <div className="waterImages">
            <div style={containerStyles}>
              <WaterSlider />
            </div>
          </div>
          <div className="centerText">
            <p id="waterSlidesId" className="coldDrinksPara">
              We started with packaged drinking water having 500ml , 1 Litre ,
              20 Litre options for the same.
            </p>
          </div>
        </div>

        <div className="sodaActive">
          <div
            style={{
              minHeight: "500px",
            }}
            className="coldDrinksHome"
          >
            {" "}
            <div className="sodaDivForHome">
              <div className="sodaImage">
                {/* <p className="headerOfSliders"> */}
                <h1 className="indiHeader"> Soda</h1>
                {/* </p> */}
                <img
                  className="sodaImgSrc"
                  src="https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Fsoda.png?alt=media&token=4a65dec1-d377-4231-87ca-b90ba6aa149a"
                  alt=""
                />
              </div>
              <p className="sodaPara">
                We progressed to manufacture soda currently having a 500ml
                option.
              </p>
            </div>
          </div>
        </div>
        <div className="softDrinksActive">
          <div
            style={{
              minHeight: "600px",
              marginBottom: "100px",
            }}
            className="coldDrinksHome"
          >
            {" "}
            <div className="coldDrinksImages">
              {" "}
              {/* <p className="headerOfSliders"> */}
              <h1 className="indiHeader">Soft Drinks</h1>
              {/* </p> */}
              <div
                style={{
                  marginBottom: "100px",
                }}
                className=""
              >
                <div className="centerColdDrinks">
                  <div style={containerStyles}>
                    <Slider />
                  </div>
                </div>
              </div>
            </div>
            <p id="coldDrinksPara" className="coldDrinksPara">
              Recently we started manufacturing soft drinks.We have around five
              flavours, Sahakar's Thril- Fizzy cola , Sahakar's Rush- Fizzy
              lemonade , Sahakar's Sprint- Fizzy Lemon , Sahakar's Orange -
              Fizzy Orange and Sahakar's Jeera- Fizzy Jeera and several more
              flavours are in the making. Currently we manufacture 250ml bottles
              only.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
